let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("geh8r")).then(() => parcelRequire('8oHcg'));